const QueryKeys = {
  user: 'user',
  users: 'users',
  'datapoints-search': 'datapoints-search',
  'widget-config': 'widget-config',
  'site-config': 'site-config',
  groups: 'groups',
  'user-groups': 'user-groups',
  notes: 'notes',
  auditLogs: 'audit-logs',
  alerts: 'alerts',
  alertConfigs: 'alert-configs',
  pointConfigs: 'point-configs',
  widgets: 'widgets',
  devices: 'devices',
};

export default QueryKeys;
